import {
  OpenUrlTarget,
  PanelContainer,
  openURL,
} from '@eCommerce/frontend-legacy-shared-library-native';
import React from 'react';

const ApplyForCasinoCredit: React.FC = () => {
  return (
    <PanelContainer
      icon="money-check-edit-alt"
      panelTitle="Apply for Casino Credit"
      bodyTitle="Whether you're playing low limit or going big, you can take advantage of casino credit!*"
      body="*Not available at all properties. Subject to credit approval. Must apply for a minimum amount of credit, which varies by property."
      primaryCTA={{
        label: 'Apply Now',
        onPress: () =>
          openURL(
            'https://nccreports.com/application/?caesarsentertainment',
            OpenUrlTarget.BLANK
          ),
      }}
    />
  );
};

export default ApplyForCasinoCredit;
